import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-cdw-user-option',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule],
  templateUrl: './cdw-user-option.component.html',
  styleUrl: './cdw-user-option.component.scss',
})
export class CdwUserOptionComponent {
  @Input({ required: true }) name!: string;
  @Input() email?: string;
  @Input() iconColor = '#1A1F31';
}
